import { versionTeamConnectionService } from "../../../services/connections/versionTeamService";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import {
  SystemTeamContributionTypes,
  VersionTeamConnection,
} from "../../../types/versionTeam";
import useVersionTeamConnectionLogic from "../../logic/connections/versionTeamConnectionLogic";
import useConnectionQueryClient from "./connectionQueryClient";

const useVersionTeamQuery = (
  teamContributionType: SystemTeamContributionTypes,
  systemLanguageType: VersionTeamConnection["system_language_type"]
) => {
  const { defaultVersionTeam, getDisplayName } = useVersionTeamConnectionLogic(
    null,
    null,
    teamContributionType,
    systemLanguageType
  );
  return useConnectionQueryClient<VersionTeamConnection>({
    service: versionTeamConnectionService,
    collection: SystemEntityCollections.VERSION_TEAM,
    defaultConnection: defaultVersionTeam,
    snackbarDisplayName: getDisplayName,
  });
};

export default useVersionTeamQuery;
